// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".martan-rating{align-items:center;display:flex;gap:4px}.martan-rating-text{color:#6c757d;font-size:12px;font-weight:600}.martan-rating--compact{align-items:center;display:flex;gap:6px}.martan-rating-compact{align-items:center;display:flex;gap:4px}.martan-rating-compact__star{flex-shrink:0}.martan-rating-compact__text{color:var(--gray-dark);font-size:12px;font-weight:600;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
